import request from "./Request";
import { encode, decode } from "base-64";
// api for creating attempt id

export const  getAttemptId = async (name, email, uid, mockId, setId) => {
  const token = localStorage.getItem("auth_token");
  const jsonData = {
    name,
    email,
  };
  try {
    const res = await request({
      url: `/api/student/v1/mocks/post/${uid}/${setId}/${mockId}`,
      type: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        uid : uid
      },
      data: JSON.stringify(jsonData),
    });
    // //console.log(res);
    return res;
  } catch (err) {
    console.error(err);
    //console.log("Error --> attempt id can not be created!!!");
    return err;
  }
};

// api for fetching main data

export const fetchQuestions = async (mockid, subject_type, uid, attemptId) => {
  const token = localStorage.getItem("auth_token");
  try {
    const res = request({
      url: `/api/student/v1/quizs/${mockid}/${subject_type}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        uid: uid,
        attemptId : attemptId
      },
    });
    return res;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

// api for submit student answers(section-wise)

export const submitSection = async (attempt_id, subject_type, payload, uid) => {
  const token = localStorage.getItem("auth_token");
  try {
    const res = request({
      url: `/api/student/v1/mocks/submitAnswer/${subject_type}/${attempt_id}`,
      type: "POST",
      data: { answers: payload },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        uid: uid,
        attemptId : attempt_id
      },
    });
    return res;
  } catch (err) {
    //console.log(err);
    return err;
  }
};

// api for college predictor

export const getPredictCollege = async (uid, payload) => {
  const token = localStorage.getItem("auth_token");
  const res = request({
    url: `/api/student/v1/analyse/read/${uid}`,
    type: "POST",
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      uid : uid
    },
  });
  return res;
};

// api for verification (MBR Side)

export const getVerified = async (email, otp, mockId) => {
  try {
    const res = request({
      url: `/api/student/v1/verify/user`,
      type: "POST",
      data: { email: email, otp: otp, mockId : mockId },
      headers: { "Content-Type": "application/json" },
    });
    return res;
  } catch (err) {
    //console.log(err);
    return err;
  }
};

//api for token validation 
export const validateToken = async (uid) => {
  try {
    const token = localStorage.getItem("auth_token");
    const res = request({
      url: `/api/student/v1/verify/validate`,
      type: "GET",
      headers: { "Content-Type": "application/json" , Authorization:"Bearer "+ token ,uid:uid},
    });
    return res;
  } catch (err) {
    //console.log(err);
    return err;
  }
};


// discard button api(Resume mock)

export const discardMock = async (attemptId, uid) => {
  const token = localStorage.getItem("auth_token");
  try {
    const res = request({
      url: `/api/student/v1/mocks/discard/${attemptId}`,
      type: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        uid: uid,
        attemptId : attemptId
      },
    });
    return res;
  } catch (err) {
    //console.log(err);
    return err;
  }
};


// api to save student response on tab closure or cache clear

export const saveStudentProgress = async (attempt_id,type,payload,uid,timer)=>{
  const token = localStorage.getItem("auth_token");
  try {
    const res = request({
      url: `/api/student/v1/mocks/submitStudentResponse/${type}/${attempt_id}`,
      type: "POST",
      data: { answers: payload ,timer:timer},
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        uid: uid,
        attemptId : attempt_id
      },
    });
    if(res){
      // localStorage.clear();
      return res;
    }
    
  } catch (err) {
    //console.log(err);
    return err;
  }
}
